<template>
  <div class="th-order-add-container">
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="form" label-width="140px">
        <el-row>
          <el-col :span="12" v-if="salesmanRole == '1'">
            <el-form-item label="采购方" prop="userId">
              <el-select v-model="formData.userId" filterable placeholder="请选择采购方" :disabled="userDisable" @change="onUserChange">
                <el-option v-for="(item, index) of userList1" :value="item.userId" :label="item.userName"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="salesmanRole == '1'">
            <el-form-item label="供应商名称" prop="supplierId">
              <el-select v-model="formData.supplierId" filterable :disabled="!formData.userId" placeholder="请选择供应商名称" @change="onSupplierChange">
                <el-option v-for="(item, index) of supplierList" :value="item.supplierId" :label="item.supplierName"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="add-box">
          <el-button type="primary" @click="onSelectOrder" icon="el-icon-plus">添加提货商品</el-button>
        </div>

        <template v-for="(item, idx) in formData.lockedList">
          <el-card class="order-list" :key="idx">
            <div class="order-item">
              <el-button type="text" icon="el-icon-close" class="close-icon" @click="onDelete(idx)"></el-button>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="订单编号">
                    <span>{{ item.orderNumber || '' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同号">
                    <span>{{ item.contractNo || '' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="规格名称">
                    <span>{{ item.specName || '' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="可用数量">
                    <span>{{ item.remainingNum }}</span>
                  </el-form-item>
                </el-col>
                <template v-if="orderType === '1'">
                  <el-col :span="12">
                    <el-form-item label="采购价格(元)">
                      <span>{{ item.specPrice || '' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="提货价格(元)" :prop="`lockedList.${idx}.pickupPrice`" required :rules="{ required: true, message: '请输入提货价格'}">
                      <el-input v-model="item.pickupPrice" placeholder="请输入提货价格"></el-input>
                    </el-form-item>
                  </el-col>
                </template>
                <el-col :span="12" v-if="orderType === '2'">
                  <el-form-item :label="(item.parentOrderId ? '确认单价' : '暂定单价') + '(元)'">{{
                      item.specPrice
                    }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="其他费用(元)" :prop="`lockedList.${idx}.otherFees`">
                    <el-input v-model="item.otherFees" placeholder="请输入其他费用"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </template>

        <el-row>
          <el-col :span="24">
            <el-form-item label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item prop="pickupOrderList" label="车辆列表">
            <el-row>
              <el-button class="mb15" type="primary" @click="addPickupOrder">新增车辆</el-button>
              <el-upload v-if="!formData.pickupId" class="ml10 vehicle-import" accept=".xls,.xlsx"
                         :action="$apis.yxcDeliveryOrder.parseVehicleImport"
                         :headers="{ token: $store.state.token }"
                         :show-file-list="false"
                         :before-upload="beforeVehicleImport"
                         :on-progress="handleVehicleImportProgress"
                         :on-success="handleVehicleImportSuccess"
                         :on-error="handleVehicleImportError">
                <el-button class="mb15" type="primary" :loading="vehicleImporting">车辆导入</el-button>
              </el-upload>
              <el-button type="text" class="ml15" icon="el-icon-download" @click="downloadTemplate">下载导入模板</el-button>
              <p>已填计划提货总数量：{{ orderListNUmber || '0' }}</p>
            </el-row>
            <el-table :data="formData.pickupOrderList">
              <!-- ========== 新增规格名称下拉 ========== -->
              <el-table-column min-width="180" prop="lockOrderId" label="规格名称">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.lockOrderId`"
                                :rules="[{ required: true, message: '请选择规格名称' }]">
                    <el-select v-model="row.lockOrderId" placeholder="请选择规格名称" filterable>
                      <el-option v-for="lock in formData.lockedList"
                                 :key="lock.orderId"
                                 :value="lock.orderId"
                                 :label="lock.specName" />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" prop="depositNum" label="计划提货数量">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.depositNum`"
                                :rules="[{ required: true, message: '请输入计划提货数量' }]">
                    <el-input-number v-model="row.depositNum" :min="0"/>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" prop="isVehicle" label="是否需要预约">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.isVehicle`">
                    <el-select v-model="row.isVehicle" placeholder="请选择">
                      <el-option :value="'1'" label="需要预约"></el-option>
                      <el-option :value="'2'" label="不需要预约"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="180" prop="vehicleDateStart" label="可预约开始日期">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.vehicleDateStart`">
                    <el-date-picker v-model="row.vehicleDateStart" type="date" placeholder="请选择开始日期"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="180" prop="vehicleDateEnd" label="可预约结束日期">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.vehicleDateEnd`">
                    <el-date-picker v-model="row.vehicleDateEnd" type="date" placeholder="请选择结束日期"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" prop="vehicleId" label="车/船号">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.vehicleId`"
                                :rules="[{ required: true, message: '请选择车辆' }]">
                    <el-select v-model="row.vehicleId" :filterable="true" :clearable="true" placeholder="输入车牌号/姓名搜索"
                               @change="(id) => carChange(id, row)">
                      <el-option v-for="(item, index) of carList" :value="item.vehicleId"
                                 :label="`${item.vehicleKey}(${item.driverName})`" :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" label="挂车号" prop="vehicleGph"></el-table-column>
              <el-table-column min-width="150" label="司机姓名" prop="driverName"></el-table-column>
              <el-table-column min-width="200" label="司机身份证" prop="driverKey"></el-table-column>
              <el-table-column min-width="150" label="司机手机号" prop="driverMobile"></el-table-column>
              <el-table-column min-width="220" prop="vehicleEndAddress" label="提货库点">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.vehicleEndAddress`">
                    <el-input v-model="row.vehicleEndAddress" placeholder="请输入提货库点" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="220" prop="vehicleStartAddress" label="卸货库点">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.vehicleStartAddress`"
                                :rules="[{ required: true, message: '请选择卸货库点' }]">
                    <el-select v-model="row.vehicleStartAddress" filterable placeholder="请选择卸货库点">
                      <el-option :value="item.warehouseId" :label="item.warehouseName"
                                 v-for="(item, index) of vehicleStartAddressList" :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="150" label="备注">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`pickupOrderList.${$index}.remark`">
                    <el-input v-model="row.remark" placeholder="请输入备注" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作">
                <template v-slot="{ $index }">
                  <el-button type="text" @click="deleteCar($index)" class="del-btn">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
    <SelectOrder :visible="showSelectOrder" :supplier-id="formData.supplierId" :order-type="orderType" :user-id="formData.userId"
                 :salesman-role="salesmanRole" :is-bulk-oil="currentIsBulkOil"
                 :select-list="formData.lockedList"
                 @confirm="handleSelectOrderConfirm" @close="showSelectOrder = false"></SelectOrder>
  </div>
</template>

<script>
import { validNumber3 } from '@/utils/validator'
import SelectOrder from './selectOrder.vue'
export default {
  name: 'ThOrderAdd',
  components: {
    SelectOrder
  },
  data() {
    return {
      showSelectOrder: false,
      orderType: '',
      vehicleStartAddressList: [],
      btnList: [{ name: '提交' }],
      rules: {
        userId: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
        supplierId: [{ required: true, message: '请选择供应商名称', trigger: 'change' }]
      },
      formData: {
        orderType: '',
        userId: '',
        supplierId: '',
        isDepositAmount: '1',
        isGoodsAmount: '1',
        pickupDeptId: '',
        fileList: [],
        isVehicle: '',
        vehicleKey: '',
        vehicleGph: '',
        driverName: '',
        driverKey: '',
        driverMobile: '',
        vehicleStartAddress: '',
        vehicleStartAddressName: '',
        vehicleEndAddress: '',
        vehicleDateStart: '',
        lockedList: [],
        pickupOrderList: []
      },
      allowDateList: [],
      salesmanRole: '2',
      isComputed: '2',
      userId: '',
      userName: '',
      supplierList: [],
      userList1: [],
      userDisable: false,
      currentWarehouseType: '',
      currentIsBulkOil: '',
      carList: [],
      currentVehicleKey: '',
      vehicleImporting: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    orderListNUmber() {
      return this.formData.pickupOrderList.reduce((pre, cur) => pre + (cur.depositNum || 0), 0)
    }
  },
  created() {
    this.orderType = this.$route.query.orderType || ''
    this.formData.orderType = this.orderType
    this.salesmanRole = this.$route.query.salesmanRole || '1'
    const pickupId = this.$route.query.pickupId || ''
    if (this.salesmanRole === '1') {
      this.loadUser1()
    }
    if (pickupId) {
      this.getDetail(pickupId)
    }
    this.loadDict()
    this.loadCarList()
  },
  beforeUnmount() {
  },
  methods: {
    onUserChange() {
      this.formData.supplierId = ''
      this.formData.lockedList = []
      this.formData.pickupOrderList = []
      this.loadSupplier()
    },
    onSupplierChange() {
      this.formData.lockedList = []
      this.formData.pickupOrderList = []
    },
    loadCarList() {
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByPage).then(res => {
        this.carList = res.list.map(item => {
          return {
            currentVehicleKey: `${item.vehicleKey}(${item.driverName})`,
            ...item
          }
        })
      })
    },
    carChange(val, row) {
      // const vehicleKey = val.split('|')[0]
      const carInfo = this.carList.find(item => item.vehicleId === val)
      if (carInfo) {
        row.driverName = carInfo.driverName
        row.driverMobile = carInfo.driverMobile
        row.driverKey = carInfo.driverKey
        row.vehicleGph = carInfo.vehicleGph
        row.vehicleKey = carInfo.vehicleKey
      } else {
        row.driverName = ''
        row.driverMobile = ''
        row.driverKey = ''
        row.vehicleGph = ''
        row.vehicleKey = ''
      }
    },
    loadDict() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage, {}).then(res => {
        this.vehicleStartAddressList = res.list
      })
    },
    loadSupplier() {
      this.$axios.get(this.$apis.deliveryOrder.selectYxcSupplierList, {
        userId: this.formData.userId,
        orderStatus: '2',
        orderType: this.orderType
      }).then(res => {
        this.supplierList = res || []
      })
    },
    loadUser1() {
      this.$axios.get(this.$apis.system.selectSysUserByList, {
        userType: '2,3',
        yxcQx: '1'
      }).then(res => {
        this.userList1 = res || []
        this.userDisable = this.userList1.length === 1
        const deptName = this.userInfo.deptName || ''
        const user = this.userDisable ? this.userList1[0] : this.userList1.find(item => item.userName === deptName)
        if (user) {
          this.formData.userId = user.userId
          this.loadSupplier()
        }
      })
    },
    onConfirmVehicleStart() {
      const warehouse = this.vehicleStartAddressList.find(w => w.warehouseId === this.formData.vehicleStartAddress)
      if (warehouse) {
        this.formData.vehicleStartAddressName = warehouse.warehouseName
        this.currentWarehouseType = warehouse.warehouseType
        this.currentIsBulkOil = warehouse.managerType === '1' ? '1' : '0'
        this.formData.isVehicle = this.currentWarehouseType === '1' ? '1' : '2'
        this.formData.lockedList = []
        this.formData.pickupOrderList = []
        this.formData.vehicleDateStart = ''
        this.loadDateSetting()
      }
    },
    loadDateSetting() {
      this.$axios.get(this.$apis.deliveryOrder.selectLyWarConfByList, {
        warehouseType: this.currentWarehouseType,
        isBulkOil: this.currentIsBulkOil
      }).then(res => {
        if (res && res.list && res.list.length > 0) {
          const info = res.list[0]
          this.allowDateList = info.wkDate.split(',') || []
        }
      })
    },
    getDetail(pickupId) {
      this.$axios.get(this.$apis.yxcDeliveryOrder.selectYxcPickupOrderByPickupId, {
        pickupId: pickupId
      }).then(res => {
        res.lockedList = res.lockedList || []
        res.fileList = res.fileList || []
        res.isVehicle = res.isVehicle === '3' ? '2' : res.isVehicle
        res.pickupOrderList = (res.pickupOrderList || []).map(item => ({
          lockOrderId: item.lockOrderId || '', // 回显绑定
          ...item,
          isVehicle: item.isVehicle === '3' ? '2' : item.isVehicle
        }))
        this.formData = res || {}
      })
    },
    addPickupOrder() {
      if (!this.formData.lockedList.length) {
        this.$message.error('请选择订单')
        return
      }
      this.formData.pickupOrderList.push({
        lockOrderId: '', // 新增：规格名称（orderId）
        depositNum: '',
        isVehicle: this.formData.isVehicle,
        vehicleDateStart: this.formData.vehicleDateStart,
        vehicleDateEnd: '',
        vehicleId: '',
        vehicleKey: '',
        vehicleGph: '',
        driverName: '',
        driverKey: '',
        driverMobile: '',
        vehicleStartAddress: this.formData.vehicleStartAddressName || '',
        vehicleEndAddress: '',
        remark: ''
      })
    },
    downloadTemplate() {
      const link = document.createElement('a')
      link.href = 'https://dcs.jscjly.com/group1/default/20260919/BECD119AAB4B434EB7DFEB7FF78427CA.xlsx'
      link.download = '车辆导入模板.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    beforeVehicleImport(file) {
      if (!this.formData.lockedList.length) {
        this.$message.error('请选择订单')
        return false
      }
      const extension = (file.name.split('.').pop() || '').toLowerCase()
      if (!['xls', 'xlsx'].includes(extension)) {
        this.$message.error('请上传xls或xlsx格式的车辆导入文件')
        return false
      }
      this.vehicleImporting = true
      return true
    },
    handleVehicleImportProgress() {
      this.vehicleImporting = true
    },
    handleVehicleImportSuccess(res) {
      this.vehicleImporting = false
      if (!res || res.code !== 200) {
        this.$message.error((res && res.message) || '车辆导入失败')
        return
      }
      const data = Array.isArray(res.data) ? res.data : []
      if (data.length === 0) {
        this.$message.warning('导入文件中没有车辆数据')
        return
      }

      // 构建 lockedList 映射：key=specName，value=orderId
      const lockSpecMap = new Map()
      this.formData.lockedList.forEach(lock => {
        lockSpecMap.set(lock.specName, lock.orderId)
      })

      const unmatchedWarehouseRows = []
      // 导入的每条转为行，追加到 pickupOrderList，不是覆盖
      const importRows = data.map((item, index) => {
        const warehouse = this.vehicleStartAddressList.find(candidate =>
          candidate.warehouseId === item.vehicleStartAddress || candidate.warehouseName === item.vehicleStartAddress
        )
        if (item.vehicleStartAddress && !warehouse) {
          unmatchedWarehouseRows.push(index + 2)
        }

        // 根据导入的规格名称匹配orderId，匹配不到 lockOrderId 置空
        const lockOrderId = lockSpecMap.get(item.specName) || ''
        const carInfo = this.carList.filter(car => {
          return car.vehicleKey === item.vehicleKey && car.driverName === item.driverName
        })
        return {
          lockOrderId: lockOrderId,
          depositNum: item.depositNum,
          isVehicle: item.isVehicle || '',
          vehicleDateStart: item.vehicleDateStart || '',
          vehicleDateEnd: item.vehicleDateEnd || '',
          vehicleId: carInfo[0]?.vehicleId || '',
          vehicleKey: carInfo[0]?.vehicleKey || item.vehicleKey || '',
          vehicleGph: carInfo[0]?.vehicleGph || item.vehicleGph || '',
          driverName: carInfo[0]?.driverName || item.driverName || '',
          driverKey: carInfo[0]?.driverKey || item.driverKey || '',
          driverMobile: carInfo[0]?.driverMobile || item.driverMobile || '',
          vehicleStartAddress: warehouse ? warehouse.warehouseId : '',
          vehicleEndAddress: item.vehicleEndAddress || '',
          remark: item.remark || ''
        }
      })

      // 追加，不替换原有数据
      this.formData.pickupOrderList.push(...importRows)

      if (unmatchedWarehouseRows.length > 0) {
        this.$confirm(`第${unmatchedWarehouseRows.join('、')}行卸货库点未匹配，请在车辆列表中重新选择`, '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        this.$message.success(`成功导入${data.length}条车辆数据`)
      }
    },
    handleVehicleImportError() {
      this.vehicleImporting = false
      this.$message.error('车辆导入失败，请重试')
    },
    deleteCar(index) {
      this.formData.pickupOrderList.splice(index, 1)
    },
    onDelete(idx) {
      const delItem = this.formData.lockedList[idx]
      this.formData.lockedList.splice(idx, 1)
      if (delItem && delItem.orderId) {
        this.formData.pickupOrderList.forEach(row => {
          if (row.lockOrderId === delItem.orderId) {
            row.lockOrderId = ''
          }
        })
      }
    },
    onSelectOrder() {
      if (!this.formData.userId) {
        this.$message.error('请选择采购方')
        return
      }
      this.showSelectOrder = true
    },
    handleSelectOrderConfirm(data) {
      console.log('confirm', data)
      const addList = data.map(item => ({
        orderId: item.orderId,
        orderNumber: item.orderNumber,
        contractNo: item.contractNo,
        specId: item.specId,
        specName: item.specName,
        specUnit: item.specUnit,
        specPrice: item.lockedPrice || '',
        pickupPrice: item.lockedPrice || '',
        otherFees: item.otherFees || '0',
        remainingNum: item.remainingNum || 0,
        parentOrderId: item.parentOrderId || ''
      }))
      const existIds = this.formData.lockedList.map(i => i.orderId)
      const filterAdd = addList.filter(i => !existIds.includes(i.orderId))
      this.formData.lockedList.push(...filterAdd)
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.formData.lockedList.length) {
            this.$message.error('请添加提货商品')
            return
          }
          for (const lockItem of this.formData.lockedList) {
            if (!lockItem.specPrice) {
              this.$message.error('提货价格不能为0或空，请检查')
              return
            }
          }
          if (!this.formData.pickupOrderList || this.formData.pickupOrderList.length === 0) {
            this.$message.error('请添加车辆列表')
            return
          }
          const info = this.formData.pickupOrderList.filter(item => !item.depositNum)
          if (info && info.length > 0) {
            this.$message.error('计划提货数量不能为0或空，请检查')
            return
          }
          if (!this.formData.pickupOrderList.every(item => validNumber3.test(item.depositNum))) {
            this.$message.error('计划数量为数字，可保留3位小数')
            return
          }
          for (const item of this.formData.pickupOrderList) {
            if (!item.lockOrderId) {
              this.$message.error('请选择规格名称')
              return
            }
            if (!item.vehicleDateStart) {
              this.$message.error('请选择可预约开始日期')
              return
            }
            if (!item.vehicleKey) {
              this.$message.error('请选择车辆')
              return
            }
            if (!item.driverName || !item.driverMobile) {
              this.$message.error('请选择包含司机姓名和手机号的车辆')
              return
            }
            if (!item.vehicleStartAddress) {
              this.$message.error('请选择卸货库点')
              return
            }
          }

          // ========== 新增组装逻辑 start ==========
          // 深拷贝，避免修改原表单数据
          const submitData = JSON.parse(JSON.stringify(this.formData))
          // 构建map方便查找
          const lockMap = {}
          submitData.lockedList.forEach(lock => {
            lockMap[lock.orderId] = lock
          })
          // 遍历车辆列表，绑定locked，删除lockOrderId
          submitData.pickupOrderList = submitData.pickupOrderList.map(row => {
            const lockedItem = lockMap[row.lockOrderId]
            delete row.lockOrderId
            delete row.vehicleId
            const locked = {
              orderId: lockedItem.orderId,
              contractNo: lockedItem.contractNo,
              orderNumber: lockedItem.orderNumber,
              otherFees: lockedItem.otherFees,
              pickupPrice: lockedItem.pickupPrice,
              specId: lockedItem.specId,
              specName: lockedItem.specName,
              specPrice: lockedItem.specPrice,
              specUnit: lockedItem.specUnit
            }
            return {
              ...row,
              locked
            }
          })
          // 删除lockedList，不传给后端
          delete submitData.lockedList
          // ========== 新增组装逻辑 end ==========

          const url = this.formData.pickupId ? this.$apis.yxcDeliveryOrder.updateYxcPickupOrder : this.$apis.yxcDeliveryOrder.insertYxcPickupOrder
          this.$axios.post(url, submitData).then(() => {
            this.$message.success('操作成功')
            setTimeout(() => {
              this.$router.back()
              this.$bus.emit('refreshOrderData')
            }, 1500)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.th-order-add-container {
}

.add-box {
  margin: 20px 0;
  text-align: right;
}

.vehicle-import {
  display: inline-block;
}

.order-list {
  margin-bottom: 20px;
}

.order-item {
  position: relative;
  padding: 15px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #f56c6c;
  z-index: 2;
}
::v-deep {
  .el-input-number, .el-date-editor {
    max-width: 100% !important;
  }
}
</style>
